class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateThemeProductDisplay();
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateThemeProductDisplay() {
    if (!this.currentVariant) return;

    const section = this.dataset.section;
    const variant = this.currentVariant;
    const moneyFormat = window.money_format || window.shop_money_format;

    if (window.Shopify?.formatMoney && moneyFormat) {
      const priceEl = document.getElementById(`ProductPrice-${section}`);
      const compareEl = document.getElementById(`ComparePrice-${section}`);

      if (priceEl) {
        priceEl.innerHTML = Shopify.formatMoney(variant.price, moneyFormat);
        priceEl.setAttribute('content', (variant.price / 100).toFixed(2));
      }

      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.innerHTML = Shopify.formatMoney(variant.compare_at_price, moneyFormat);
          compareEl.classList.remove('hide');
        } else {
          compareEl.classList.add('hide');
        }
      }
    }

    const skuEl = document.querySelector('.variant-sku');
    if (skuEl) skuEl.textContent = variant.sku || '';

    if (typeof window.updatePricing === 'function') {
      window.updatePricing();
    }

    const masterSelect = document.getElementById('product-selectors');
    if (masterSelect) {
      masterSelect.value = variant.id;
      if (window.jQuery) window.jQuery(masterSelect).trigger('change');
    }

    const featuredImage = variant.featured_image || variant.featured_media?.preview_image;
    if (featuredImage && window.jQuery && window.Shopify?.Image) {
      const originalImage = window.jQuery("img[id|='product-featured-image']");
      if (originalImage.length) {
        Shopify.Image.switchImage(featuredImage, originalImage[0], function (newImageSizedSrc) {
          window.jQuery('.slider-nav img').each(function () {
            const thumbSrc = window.jQuery(this).attr('src') || '';
            const zoomSrc = thumbSrc
              .replace('100x100', '1024x1024')
              .replace('150x150', '1024x1024')
              .replace('160x160', '1024x1024');

            if (zoomSrc === newImageSizedSrc) {
              window.jQuery(this).closest('.item').trigger('click');
              return false;
            }
          });
        });
      }
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;

    const featuredMedia = this.currentVariant.featured_media;
    if (!featuredMedia) return;

    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${featuredMedia.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => { parent.scroll(0, 0) });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (!input) return;
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
        this.updateThemeProductDisplay();
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings?.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;

    const addButtonText = addButton.querySelector(`#AddToCartText-${this.dataset.section}`) || addButton;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      if (window.variantStrings?.addToCart) addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    const addButtonText = addButton.querySelector(`#AddToCartText-${this.dataset.section}`) || addButton;
    addButtonText.textContent = window.variantStrings?.unavailable || 'Unavailable';
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);
